//constants
import {
	DELETE_UPPER,
	DETAILS,
	MARK_AS_PAID,
	SEND_PAYMENT_LINK,
	TICKETS_TIERS,
	PAY_STATUS as PAYMENT_STATUS_TITLE,
	SEATS,
	ALL_TICKETS_TIERS,
	COLLECT_PAYMENT,
} from '@/utils/constants';

import {PAYMENT_STATUS, SEATS_STATE} from '@/utils/enums/tables.enum';
//helpers
import {camelize} from '@/utils/helpers';
//types
import {IFilterGroup, IOrganizationTicketsTiers} from '@/utils/types';

export const tableTicketsMenuContent = [DETAILS, MARK_AS_PAID, COLLECT_PAYMENT, SEND_PAYMENT_LINK, DELETE_UPPER];

export const tableAndTicketsDefaultFilterValues = {
	sortColumn: '',
	isOrderDesc: false,
	status: camelize(SEATS_STATE.ALL_SEATS),
	isPaid: camelize(PAYMENT_STATUS.ALL),
	tierIds: null,
};

export const tableAndTicketsDefaultFilterData: IFilterGroup[] = [
	{
		title: SEATS,
		options: [
			{title: SEATS_STATE.ALL_SEATS, isSelected: true},
			{title: SEATS_STATE.EMPTY_SEATS, isSelected: false},
		],
	},
	{
		title: PAYMENT_STATUS_TITLE,
		options: [
			{title: PAYMENT_STATUS.ALL, isSelected: true},
			{title: PAYMENT_STATUS.PAID, isSelected: false},
			{title: PAYMENT_STATUS.PENDING, isSelected: false},
		],
	},
	{
		title: TICKETS_TIERS,
		options: [{title: ALL_TICKETS_TIERS, isSelected: true, id: null}],
	},
];

export const updatedTableAndTicketsFilterOptions = (
	ticketsTiers: IOrganizationTicketsTiers[],
	filterData: IFilterGroup[]
) =>
	filterData.map((filterGroup) =>
		filterGroup.title === TICKETS_TIERS
			? {
					...filterGroup,
					options: [
						{
							title: ALL_TICKETS_TIERS,
							isSelected: !filterGroup.options.every((option) => !option.isSelected && option.id === null),
							id: null,
							isCheckBox: false,
						},
						...ticketsTiers.map((tier) => ({title: tier.name, isSelected: false, id: tier.id, isCheckBox: true})),
					],
			  }
			: filterGroup
	);

export const handleSetTierIds = (currentTierIds: number[] | null, id?: number) => {
	if (!id) return null;

	const isIdInTierIds = currentTierIds ? currentTierIds.includes(id) : false;

	if (isIdInTierIds) {
		const newTierIds = currentTierIds?.filter((tierId) => tierId !== id) || [];
		return newTierIds.length > 0 ? newTierIds : null;
	}
	return [...(currentTierIds || []), id];
};

export const getUpdatedFilterData = (
	currentFilterData: IFilterGroup[],
	groupTitle: string,
	optionTitle: string,
	selectedCheckboxId?: number | null
) => {
	const indexToUpdate = currentFilterData.findIndex((filterGroup) => filterGroup.title === groupTitle);

	return currentFilterData.map((filterGroup, index) => {
		if (index !== indexToUpdate) return filterGroup;

		switch (groupTitle) {
			case SEATS:
			case PAYMENT_STATUS_TITLE:
				return {
					...filterGroup,
					options: filterGroup.options.map((option) => ({
						...option,
						isSelected: option.title === optionTitle,
					})),
				};

			case TICKETS_TIERS:
				const newOptions = filterGroup.options.map((option) => {
					if (option.isCheckBox && option.id === selectedCheckboxId) {
						return {
							...option,
							isSelected: !option.isSelected,
						};
					}
					return {
						...option,
					};
				});

				const hasSelectedCheckBox = newOptions.some((option) => option.isCheckBox && option.isSelected);

				const updatedOptions = newOptions.map((option) => {
					if ((!option.isCheckBox && hasSelectedCheckBox) || (option.isCheckBox && !hasSelectedCheckBox)) {
						return {
							...option,
							isSelected: false,
						};
					}

					if (!option.isCheckBox && !hasSelectedCheckBox) {
						return {
							...option,
							isSelected: true,
						};
					}

					return option;
				});

				return {
					...filterGroup,
					options: updatedOptions,
				};

			default:
				return filterGroup;
		}
	});
};
